import { DateRange } from 'react-day-picker';

export function addDayToRange(day: Date, range: DateRange | null): DateRange {
  if (!range) {
    return { from: day, to: day };
  }

  if (!range.from) {
    return { ...range, from: day };
  }

  if (!range.to) {
    return day < range.from ? { from: day, to: range.from } : { ...range, to: day };
  }

  if (day < range.from) {
    return { from: day, to: range.to };
  }

  if (day > range.to) {
    return { from: range.from, to: day };
  }

  return {
    from: range.from,
    to: day,
  };
}
